import { useState, useEffect } from "react";
import "./reviseRosterForm.css";
import { portalUrl } from "./Utility/util";

const API_URL = `${portalUrl}/o/c/reservationrosters/`;

const REGIONS = [
  "ALL INDIA",
  "ANDAMAN AND NICOBAR ISLANDS",
  "ARUNACHAL PRADESH",
  "ASSAM",
  "Andhra Pradesh",
  "BIHAR",
  "CHANDIGARH",
  "CHHATISGARH",
  "DELHI",
  "Dadra and nagar haveli",
  "Daman and Diu",
  "GOA",
  "GUJARAT",
  "HARYANA",
  "HIMACHAL PRADESH",
  "JAMMU AND KASHMIR",
  "JHARKHAND",
  "KARNATAKA",
  "KERALA",
  "LADAKH",
  "LAKSHADWEEP",
  "MADHYA PRADESH",
  "MAHARASHTRA",
  "MANIPUR",
  "MEGHALAYA",
  "MIZORAM",
  "NAGALAND",
  "ODISHA",
  "PUDUCHERRY",
  "PUNJAB",
  "RAJASTHAN",
  "SIKKIM",
  "TAMIL NADU",
  "TELANGANA",
  "TRIPURA",
  "UTTAR PRADESH",
  "UTTARAKHAND",
  "WEST BENGAL"
];

export default function ReviseRosterForm() {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [region, setRegion] = useState("");
  const [cadre, setCadre] = useState("");
  const [type, setType] = useState("");
  const [date, setDate] = useState("");
  const [details, setDetails] = useState("");

  const [matchedRow, setMatchedRow] = useState(null);
  const [searched, setSearched] = useState(false);

  // Cascading unique options
  const cadres = [...new Set(
    allData.filter((r) => !region || r.region === region).map((r) => r.cadre)
  )].filter(Boolean).sort();

  const types = [...new Set(
    allData
      .filter((r) => (!region || r.region === region) && (!cadre || r.cadre === cadre))
      .map((r) => r.type)
  )].filter(Boolean).sort();

  const dates = [...new Set(
    allData
      .filter((r) =>
        (!region || r.region === region) &&
        (!cadre || r.cadre === cadre) &&
        (!type || r.type === type)
      )
      .map((r) => r.date)
  )].filter(Boolean).sort();

  const detailsList = [...new Set(
    allData
      .filter((r) =>
        (!region || r.region === region) &&
        (!cadre || r.cadre === cadre) &&
        (!type || r.type === type) &&
        (!date || r.date === date)
      )
      .map((r) => r.details)
  )].filter(Boolean).sort();

  const handleRegionChange = async (val) => {
    setRegion(val); setCadre(""); setType(""); setDate(""); setDetails("");
    setMatchedRow(null); setSearched(false);
    setAllData([]);
    setError("");

    if (!val) return;

    try {
      setLoading(true);


      // Pehle totalCount pata karo
      const firstRes = await fetch(`${API_URL}?filter=region eq '${val}'&pageSize=1`, {
        method: "GET",
        credentials: "include",
        headers: {
          "X-CSRF-Token": window.Liferay?.authToken,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const firstData = await firstRes.json();
      const total = firstData.totalCount || 500;

      // Ab sab ek saath fetch karo
      const response = await fetch(`${API_URL}?filter=region eq '${val}'&pageSize=${total}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "X-CSRF-Token": window.Liferay?.authToken,  // ✅
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();

      const rows = Array.isArray(data)
        ? data
        : data.items || data.results || data.data || [];

      setAllData(rows);
    } catch (err) {
      setError("Could not load data from API: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCadreChange = (val) => {
    setCadre(val); setType(""); setDate(""); setDetails("");
    setMatchedRow(null); setSearched(false);
  };

  const handleTypeChange = (val) => {
    setType(val); setDate(""); setDetails("");
    setMatchedRow(null); setSearched(false);
  };

  const handleDateChange = (val) => {
    setDate(val); setDetails("");
    setMatchedRow(null); setSearched(false);
  };

  const handleSearch = () => {
    setSearched(true);
    const found = allData.find(
      (r) =>
        r.region === region &&
        r.cadre === cadre &&
        r.type === type &&
        r.date === date &&
        r.details === details
    );
    setMatchedRow(found || null);
  };

  const handleViewFile = () => {
    if (matchedRow?.filePath) {
      const url = matchedRow.filePath.startsWith("http")
        ? matchedRow.filePath
        : `${portalUrl}${matchedRow.filePath}`;
      window.open(url, "_blank");
    }
  };

  const handleClear = () => {
    setRegion(""); setCadre(""); setType(""); setDate(""); setDetails("");
    setMatchedRow(null); setSearched(false);
    setAllData([]);
    setError("");
  };

  const isSearchEnabled = region && cadre && type && date && details;

  return (
    <div className="form-container">
      {error && <div className="alert alert-error">⚠️ {error}</div>}

      <div className="form-grid">
        {/* Region */}
        <div className="form-group">
          <label>Region *</label>
          <select value={region} onChange={(e) => handleRegionChange(e.target.value)}>
            <option value="">Please Select Region</option>
            {REGIONS.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>

        {/* Cadre */}
        <div className="form-group">
          <label>Cadre *</label>
          <select value={cadre} onChange={(e) => handleCadreChange(e.target.value)} disabled={!region || loading}>
            <option value="">Select Cadre</option>
            {cadres.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>

        {/* Type */}
        <div className="form-group">
          <label>Type *</label>
          <select value={type} onChange={(e) => handleTypeChange(e.target.value)} disabled={!cadre}>
            <option value="">Select Type</option>
            {types.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>

        {/* Date */}
        <div className="form-group">
          <label>Date *</label>
          <select value={date} onChange={(e) => handleDateChange(e.target.value)} disabled={!type}>
            <option value="">Select Date</option>
            {dates.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>

        {/* Details - full width */}
        <div className="form-group full-width">
          <label>Details *</label>
          <select
            value={details}
            onChange={(e) => { setDetails(e.target.value); setMatchedRow(null); setSearched(false); }}
            disabled={!date}
          >
            <option value="">Select</option>
            {detailsList.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
      </div>

      {/* Loading indicator */}
      {loading && <div className="loading-text">Loading data...</div>}

      {/* Result Messages */}
      {searched && !matchedRow && (
        <div className="alert alert-warning">No record found for the selected criteria.</div>
      )}
      {searched && matchedRow && (
        <div className="alert alert-success">
          ✅ Record found:
        </div>
      )}

      {/* Buttons */}
      <div className="button-group">
        {matchedRow && (
          <button className="view-btn" onClick={handleViewFile}>
            📄 View File
          </button>
        )}
        <button className="search-btn" onClick={handleSearch} disabled={!isSearchEnabled || loading}>
          Search
        </button>
        <button className="clear-btn" onClick={handleClear}>
          Clear
        </button>
      </div>
    </div>
  );
}